import { render, staticRenderFns } from "./MantenedorRegiones.vue?vue&type=template&id=1914a8f9&scoped=true&"
import script from "./MantenedorRegiones.vue?vue&type=script&lang=js&"
export * from "./MantenedorRegiones.vue?vue&type=script&lang=js&"
import style0 from "./MantenedorRegiones.vue?vue&type=style&index=0&id=1914a8f9&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1914a8f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1914a8f9')) {
      api.createRecord('1914a8f9', component.options)
    } else {
      api.reload('1914a8f9', component.options)
    }
    module.hot.accept("./MantenedorRegiones.vue?vue&type=template&id=1914a8f9&scoped=true&", function () {
      api.rerender('1914a8f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/tools/vistas/MantenedorRegiones.vue"
export default component.exports